class YoutubeMusic {
  constructor (data) {
    this.id = data ? data.id : ''
    this.title = data ? data.title : ''
    this.artist = data ? data.artist : ''
    this.duration = data ? data.duration : ''
    this.link = data ? data.link : ''
    this.audio = data ? data.audio : ''
    this.image = data ? data.image : ''
    this.poster = data ? data.imageUrl : ''
    this.mp3 = data ? data.audioUrl : ''
    this.created_at = data ? data.created_at : ''
  }
}

export default YoutubeMusic



// WEBPACK FOOTER //
// ./src/models/YoutubeMusic.js